import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API } from '../App';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    handleOAuthCallback();
  }, []);

  const handleOAuthCallback = async () => {
    try {
      // Get session_id from URL hash
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('No session ID found');
        navigate('/login');
        return;
      }

      // Exchange session_id for user data
      const formData = new FormData();
      formData.append('session_id', sessionId);

      const response = await axios.post(`${API}/auth/session`, formData, {
        withCredentials: true // Important for cookies
      });

      const { user, session_token } = response.data;

      // Store user data and token
      login(session_token, user);

      toast.success(`Welcome, ${user.name}!`);
      navigate('/dashboard');
    } catch (error) {
      console.error('OAuth callback error:', error);
      toast.error('Authentication failed. Please try again.');
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;